class BattleshipObjectGroup {
    objectId: number;
    objectTypeId: number;

    constructor(objectId: number, objectTypeId: number) {
        this.objectId = objectId;
        this.objectTypeId = objectTypeId;
    }
}

export default BattleshipObjectGroup;